import { get2 } from "@/shared/axios";
import useBranchId from "@/shared/hooks/useBranchId";
import { MapScreenSettings } from "@/shared/v2/queries/interfacesV2";
import { useQuery } from "@tanstack/react-query";
import { withDefaultSettings } from "./helpers";

const useMapOrdersSettingsQuery = () => {
  const branchId = useBranchId();

  const query = useQuery<MapScreenSettings>({
    queryKey: ["mapscreensettings", branchId],
    queryFn: () =>
      get2(`/internal/secure/pos/v1/couriers/map/screen/settings/${branchId}`),
    enabled: branchId !== -1,
    select: withDefaultSettings,
  });
  return query;
};

export default useMapOrdersSettingsQuery;
